<retrieval-call-flow [retrievalId]="emrId" [retrievalType]="emr" [callType]="callDirection"></retrieval-call-flow>
